import React, { ReactElement } from 'react'
import { FeatureList, FeatureChip } from './FeatureList'
import {
  AudioIcon,
  AirConIcon,
  CircleTickIcon,
  TvIcon,
  WhiteboardIcon,
  ParkingIcon,
  DisabledIcon,
} from '../../../Components/Icons/Facilities'
import { FacilityFragment } from './FacilitiesList.generated-types'

// Facilities are stored by numeric id and string label.
const facilityIcons: Record<string, ReactElement> = {
  25: <AudioIcon />, // "Audio Equipment"
  16: <AirConIcon />, // "Air Conditioning"
  3: <CircleTickIcon />, // "Natural Light"
  4: <CircleTickIcon />, // "Outdoor Space"
  15: <CircleTickIcon />, // "Breakout Spaces"
  56: <CircleTickIcon />, // "Close to Transport Links"
  26: <TvIcon />, // "TV/Projector"
  14: <WhiteboardIcon />, // "Whiteboards/Flipcharts"
  37: <ParkingIcon />, // "Parking"
  8: <DisabledIcon />, // "Disabled Access"
}

const generateFacilityListItem = (facility: FacilityFragment): ReactElement => (
  <li key={facility.ID}>
    {facility.ID && (
      <FeatureChip
        aria-hidden='true'
        variant='outlined'
        icon={facilityIcons[facility.ID.toString()]}
        label={facility.name}
      />
    )}
  </li>
)

interface FacilityListProps {
  facilities: FacilityFragment[]
}

const FacilityList = ({ facilities }: FacilityListProps): JSX.Element => (
  <FeatureList
    featureItems={facilities.map(generateFacilityListItem)}
    heading='Facilities'
    className='facilities'
  />
)

export default FacilityList
